import { Singleton } from '@visiba/instantiation';

@Singleton()
export class SpaContextService {
	public static webVersion: string | null = null;

	constructor() {
		// Empty
	}
}
